import { render, staticRenderFns } from "./AppMy.vue?vue&type=template&id=7854bef4&scoped=true"
import script from "./AppMy.vue?vue&type=script&lang=ts"
export * from "./AppMy.vue?vue&type=script&lang=ts"
import style0 from "./AppMy.vue?vue&type=style&index=0&id=7854bef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854bef4",
  null
  
)

export default component.exports